import { Route } from '@angular/router';

export const PrescriptionsDraftRoute: Route = {
  path: 'prescriptions-draft',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/prescriptions_draft_shell'
    ).then((c) => c.PrescriptionsDraftShellRoutes);
  },
};
